import isEqual from 'lodash/isEqual';

export function isSetEqual(a: unknown[] | undefined, b: unknown[] | undefined): boolean {
	const aSet = new Set(a || []);
	const bSet = new Set(b || []);
	return isEqual(aSet, bSet);
}
